import { DataStorage } from './data-storage/data-storage';
import { Wall } from './wall/wall';
import { AuthService } from './auth-service/auth-service';
import { User } from './user/user';
import { FirebaseActions } from './firebase-actions/firebase-actions';
import { ShareData } from './share-data/share-data';
import { Connectivity } from './connectivity/connectivity';
import { CameraActions } from './camera-actions/camera-actions';
export {
    Wall,
    AuthService,
    User,
    FirebaseActions,
    ShareData,
    Connectivity,
    CameraActions,
    DataStorage
};



// WEBPACK FOOTER //
// ./src/providers/providers.ts